
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, Phone, MapPin } from 'lucide-react';
import { Admin } from '@/types/admin.types';

interface AdminContactCardProps {
  admin: Admin;
}

const AdminContactCard = ({ admin }: AdminContactCardProps) => {
  return (
    <Card className="card-glow">
      <CardHeader>
        <CardTitle className="text-xl">Contact Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start">
          <Mail className="h-5 w-5 mr-3 text-muted-foreground mt-0.5" />
          <div>
            <p className="text-sm font-medium">Email</p>
            <p className="text-sm text-muted-foreground">{admin.email}</p>
          </div>
        </div>
        <div className="flex items-start">
          <Phone className="h-5 w-5 mr-3 text-muted-foreground mt-0.5" />
          <div>
            <p className="text-sm font-medium">Phone</p>
            <p className="text-sm text-muted-foreground">{admin.phone}</p>
          </div>
        </div>
        <div className="flex items-start">
          <MapPin className="h-5 w-5 mr-3 text-muted-foreground mt-0.5" />
          <div>
            <p className="text-sm font-medium">Address</p>
            <p className="text-sm text-muted-foreground">
              {admin.address}, {admin.city}, {admin.country}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdminContactCard;
